import { ProfileStatus } from '@trustoo/enums/ProfileStatus'

/**
 * Mirror of `ProvidersTable::PROFILE_STATUSES_DISABLED`: the statuses in which a matched provider
 * counts as gone. The backend refuses to confirm new matches for them and reports their existing
 * matches as chatting-disallowed; the frontends hide the send bar and show the "pro gone" message.
 *
 * Not the visibility rule: only `ENABLED` profiles are shown on the platform, so on-hold, untouched,
 * ghost and new-import providers are hidden yet remain messageable within an existing match.
 * Use {@link isProfileDisabled} rather than reading the list directly.
 */
export const DISABLED_PROFILE_STATUSES: readonly ProfileStatus[] = [
    ProfileStatus.DISABLED,
    ProfileStatus.GDPR,
    ProfileStatus.DISABLED_BAD_PROFILE,
    ProfileStatus.CHURNED,
]

/** Whether a provider with this `status` counts as disabled; see {@link DISABLED_PROFILE_STATUSES}. */
export function isProfileDisabled(status: number): boolean {
    return DISABLED_PROFILE_STATUSES.includes(status)
}
